export default __webpack_public_path__ + "static/media/2412257.b184d26b.webp";